import { NgModule, ModuleWithProviders } from "@angular/core";

@NgModule({
    declarations: [],
    imports: [],
    exports: []
})
export class SurveyAuthorizationModule {
    static forRoot(): ModuleWithProviders<SurveyAuthorizationModule> {
        return {
            ngModule: SurveyAuthorizationModule,
            providers: [
                // {
                //     provide: AUTH0_CONFIG,
                //     useValue: config
                // },
                // {
                //     provide: HTTP_INTERCEPTORS,
                //     useClass: Auth0InterceptorService,
                //     multi: true
                // }
            ]
        };
    }
}
